import React, { memo } from 'react'

import {
  TagComponent,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, string } from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function Tags({ tags = EMPTY_ARRAY }) {
  return (
    <div className="search-subscription__tags">
      {tags
        .map((tag) => (
          <TagComponent
            key={tag}
            color="grey"
            type="secondary"
          >
            {tag}
          </TagComponent>
        ))}
    </div>
  )
}


Tags.propTypes = {
  tags: arrayOf(string),
}

const mapStateToProps = ({
  filtersOptions: {
    fileTypes,
    modelType,
    polygons,
    priceRange,
    pricing,
    licenses,
  },
  selectedFilters: {
    fileTypes: selectedFileTypes = [],
    modelType: selectedModelTypes = {},
    polygonRange: selectedPolygonRange = [],
    priceRange: selectedPriceRange = [],
    pricing: selectedPricing = {},
    licenses: selectedLicenses = [],
    suggested_keywords: suggestedKeywords = '',
  },
}) => {
  function getLabel(value, options = []) {
    const filter = options.find(f => f.value === value)

    return filter ? filter.label : ''
  }

  function canUseObject(obj) {
    return obj && typeof obj === 'object' && Object.keys(obj).length
  }

  const filetypeTags = Array.isArray(selectedFileTypes)
    ? selectedFileTypes.map((fileType) => getLabel(fileType, fileTypes.filters))
    : []

  const modelTypeTags = canUseObject(selectedModelTypes)
    ? Object.entries(selectedModelTypes)
      .filter(([_, value]) => value === '1')
      .map(([key, _]) => getLabel(key, modelType.filters))
    : []

  const priceRangeTags = Array.isArray(selectedPriceRange)
    ? selectedPriceRange.map((range) => getLabel(range, priceRange.filters))
    : []

  const pricingTags = canUseObject(selectedPricing)
    ? Object.entries(selectedPricing)
      .filter(([_, value]) => value === '1')
      .map(([key, _]) => getLabel(key, pricing.filters))
    : []

  const polygonTags = Array.isArray(selectedPolygonRange)
    ? selectedPolygonRange.map((polygon) => getLabel(polygon, polygons.filters))
    : []
  const licenseTags = Array.isArray(selectedLicenses)
    ? selectedLicenses.map((license) => getLabel(license, licenses.filters))
    : []

  const suggestedKeywordsTags = suggestedKeywords ? suggestedKeywords.split(',') : []

  return {
    tags: [
      ...suggestedKeywordsTags,
      ...filetypeTags,
      ...modelTypeTags,
      ...priceRangeTags,
      ...pricingTags,
      ...polygonTags,
      ...licenseTags,
    ],
  }
}

export default WithListingPageContext(mapStateToProps)(memo(Tags))
